/* The small controls every person section is built from.

   The admissions page and the student page each had their own `inputClass`
   and their own one-off select wrapper, with different focus rings, which is
   part of why the two pages never quite matched even where they showed the
   same field. This is the one definition of both. */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export const inputClass =
  'border-[rgba(6, 43, 26,0.16)] focus-visible:ring-[3px] focus-visible:ring-[rgba(212, 175, 55,0.35)] focus-visible:ring-offset-0 focus-visible:border-[#D4AF37]';

/* A select over `{ value, label, disabled }` options.

   Radix treats `value=""` as "no value", so an unset field passes `undefined`
   and shows the placeholder rather than rendering an empty selected item. */
export function SelectControl({ value, onChange, options, placeholder, disabled, ariaLabel }) {
  return (
    <Select value={value || undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={inputClass} aria-label={ariaLabel}>
        <SelectValue placeholder={placeholder || 'Select…'} />
      </SelectTrigger>
      <SelectContent>
        {(options || []).map((option) => (
          <SelectItem key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

/* The card chrome every section shares. */
export const sectionCardClass = 'border border-[rgba(6, 43, 26,0.08)] shadow-sm';
export const sectionTitleClass = 'text-base text-[#062B1A] flex items-center gap-2';
export const sectionTitleStyle = { fontFamily: 'var(--font-display)' };

export default SelectControl;
